import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ModalContainer } from '@containers/layout';
import ApartmentForm from '@containers/auth/ApartmentForm';
import DialogBox from '@components/DialogBox';
import { AuthSelectors } from '@redux/AuthRedux';

function ApartmentModal(props) {
  const { show, dismiss } = props;

  return (
    <DialogBox show={show} onClickOutside={dismiss}>
      <ModalContainer>
        <ApartmentForm onSubmit={dismiss} onCancel={dismiss} />
      </ModalContainer>
    </DialogBox>
  );
}

ApartmentModal.propTypes = {
  user: PropTypes.object,
  show: PropTypes.bool,
  dismiss: PropTypes.func
};

const mapStatesToProps = state => ({
  user: AuthSelectors.selectCurrentUser(state)
});

export default connect(mapStatesToProps)(ApartmentModal);
